import { A11yModule } from '@angular/cdk/a11y';
import { NgTemplateOutlet } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  TemplateRef,
  inject,
  input,
  output,
} from '@angular/core';

import { TooltipPlacement } from './tooltip-placement';

@Component({
  selector: 'reader-ui-tooltip',
  imports: [A11yModule, NgTemplateOutlet],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.id]': 'id()',
    '[class]': 'placement()',
  },
})
export class TooltipComponent implements AfterViewInit {
  readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly id = input.required<string>();
  readonly placement = input<TooltipPlacement>('top');
  readonly tooltipMessage = input<string>('');
  readonly templateRef = input<TemplateRef<unknown> | null>(null);
  readonly afterViewInit = output();

  ngAfterViewInit(): void {
    this.afterViewInit.emit();
  }
}